<div class="table-grid-container">
  <!-- Controles de Visualización -->
  <div class="grid-controls">
    <div class="control-group">
      <button class="control-btn" (click)="zoomIn()" title="Acercar">
        <i class="fas fa-search-plus"></i>
      </button>
      <button class="control-btn" (click)="zoomOut()" title="Alejar">
        <i class="fas fa-search-minus"></i>
      </button>
      <button class="control-btn" (click)="fitAllTablesInView()" title="Ver todas las mesas">
        <i class="fas fa-compress-arrows-alt"></i>
      </button>
    </div>
    <div class="control-group">
      <button *ngIf="canCreate" class="control-btn" (click)="onCreateTableClick()" title="Crear Nueva Mesa">
        <i class="fas fa-plus"></i>
      </button>
      <button 
        *ngIf="canEdit"
        class="control-btn" 
        [class.active]="snapToGrid" 
        (click)="toggleSnapToGrid()" 
        title="Snap to Grid">
        <i class="fas fa-th"></i>
      </button>
      <!-- Botones del Simulador (solo si puede editar) -->
      <div class="simulation-controls-inline" *ngIf="canEdit && (simulationState$ | async) as state">
        <button 
          *ngIf="!state.isRunning"
          class="control-btn simulation-btn play-btn" 
          (click)="startSimulation()"
          title="Iniciar Simulación">
          <i class="fas fa-play"></i>
        </button>
        <button 
          *ngIf="state.isRunning && !state.isPaused"
          class="control-btn simulation-btn pause-btn" 
          (click)="pauseSimulation()"
          title="Pausar Simulación">
          <i class="fas fa-pause"></i>
        </button>
        <button 
          *ngIf="state.isRunning && state.isPaused"
          class="control-btn simulation-btn resume-btn" 
          (click)="resumeSimulation()"
          title="Reanudar Simulación">
          <i class="fas fa-play"></i>
        </button>
        <button 
          *ngIf="state.isRunning || state.elapsedTime > 0"
          class="control-btn simulation-btn stop-btn" 
          (click)="stopSimulation()"
          title="Detener Simulación">
          <i class="fas fa-stop"></i>
        </button>
        <button 
          *ngIf="!state.isRunning && state.elapsedTime > 0"
          class="control-btn simulation-btn report-btn" 
          (click)="showReport()"
          title="Ver Reporte">
          <i class="fas fa-chart-bar"></i>
        </button>
      </div>
      <div *ngIf="canEdit" class="organize-menu-wrapper" (click)="$event.stopPropagation()">
        <button 
          class="control-btn organize-btn" 
          [class.active]="showOrganizeMenu"
          (click)="toggleOrganizeMenu()" 
          title="Organizar Mesas">
          <i class="fas fa-th"></i>
          <i class="fas fa-chevron-down organize-chevron" [class.rotated]="showOrganizeMenu"></i>
        </button>
        <div class="organize-menu" [class.open]="showOrganizeMenu" *ngIf="showOrganizeMenu">
          <button class="organize-menu-item" (click)="organizeTablesGrid()" title="Cuadrícula">
            <i class="fas fa-th"></i>
            <span>Cuadrícula</span>
          </button>
          <button class="organize-menu-item" (click)="organizeTablesLShape()" title="Forma L">
            <i class="fas fa-angle-down"></i>
            <span>Forma L</span>
          </button>
          <button class="organize-menu-item" (click)="organizeTablesUShape()" title="Forma U">
            <i class="fas fa-shapes"></i>
            <span>Forma U</span>
          </button>
          <button class="organize-menu-item" (click)="organizeTablesCircular()" title="Circular">
            <i class="fas fa-circle"></i>
            <span>Circular</span>
          </button>
          <button class="organize-menu-item" (click)="organizeTablesLinear()" title="Lineal">
            <i class="fas fa-arrows-alt-h"></i>
            <span>Lineal</span>
          </button>
          <button class="organize-menu-item" (click)="organizeTablesTwoRows()" title="Dos Filas">
            <i class="fas fa-grip-lines"></i>
            <span>Dos Filas</span>
          </button>
        </div>
      </div>
    </div>
    <div class="zoom-indicator">
      {{ Math.round(zoomLevel * 100) }}%
    </div>
    
    <!-- Métricas del Simulador -->
    <div class="simulation-metrics-inline" *ngIf="canEdit && (simulationState$ | async) as state">
      <div class="metric-inline" *ngIf="state.isRunning || state.elapsedTime > 0">
        <span class="metric-label-inline">Tiempo:</span>
        <span class="metric-value-inline">{{ formatTime(state.elapsedTime) }}</span>
      </div>
      <div class="metric-inline" *ngIf="state.isRunning || state.elapsedTime > 0">
        <span class="metric-label-inline">Clientes:</span>
        <span class="metric-value-inline">{{ state.metrics.totalCustomers }}</span>
      </div>
      <div class="metric-inline" *ngIf="state.isRunning || state.elapsedTime > 0">
        <span class="metric-label-inline">Atendidos:</span>
        <span class="metric-value-inline">{{ state.metrics.customersServed }}</span>
      </div>
      <div class="metric-inline" *ngIf="state.isRunning || state.elapsedTime > 0">
        <span class="metric-label-inline">Esperando:</span>
        <span class="metric-value-inline">{{ state.metrics.customersWaiting }}</span>
      </div>
    </div>
  </div>

  <!-- Grid Container -->
  <div 
    #gridContainer
    class="tables-grid" 
    [style.transform]="'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomLevel + ')'"
    [style.transform-origin]="'top left'"
    (mousedown)="onGridMouseDown($event)"
    (wheel)="onWheel($event)"
    [class.panning]="isPanning">
    
    <!-- Grid Background -->
    <div class="grid-background" *ngIf="snapToGrid"></div>

    <!-- Mesas -->
    <div 
      *ngFor="let table of tables"
      class="table-item"
      [class.selected]="isTableSelected(table.id)"
      [class.dragging]="isTableDragging(table.id)"
      [ngStyle]="getTableStyle(table)"
      (mousedown)="onTableMouseDown(table, $event)"
      (click)="onTableClick(table, $event)"
      (dblclick)="onTableDoubleClick(table)">
      
      <div class="table-icon">
        <i [class]="getTableStatusIcon(table)"></i>
      </div>
      
      <div class="table-number">{{ table.number }}</div>
      
      <div class="table-info">
        <div class="table-capacity">
          <i class="fas fa-user"></i>
          <span>{{ table.capacity }}</span>
        </div>
        <div class="table-status-badge">
          {{ getTableStatusLabel(table) }}
        </div>
      </div>

      <div class="table-linked-indicator" *ngIf="table.isLinked()">
        <i class="fas fa-link"></i>
      </div>

      <div class="table-drag-handle" *ngIf="canEdit">
        <i class="fas fa-grip-vertical"></i>
      </div>
      
      <!-- Botón eliminar mesa -->
      <button 
        *ngIf="canEdit"
        class="table-delete-btn" 
        (click)="onDeleteTableClick(table, $event)"
        title="Eliminar Mesa">
        <i class="fas fa-times"></i>
      </button>
    </div>


    <!-- Indicador de arrastre -->
    <div class="drag-indicator" *ngIf="dragState.isDragging">
      <i class="fas fa-arrows-alt"></i>
      <span>Arrastrando mesa {{ dragState.table?.number }}</span>
    </div>
  </div>

  <!-- Leyenda y Ayuda -->
  <div class="tables-legend">
    <div class="legend-section">
      <h4><i class="fas fa-info-circle"></i> Controles</h4>
      <div class="legend-items">
        <div class="legend-item">
          <span class="legend-key">Arrastrar</span>
          <span class="legend-desc">Click y arrastra para mover</span>
        </div>
        <div class="legend-item">
          <span class="legend-key">Ctrl + Click</span>
          <span class="legend-desc">Editar mesa</span>
        </div>
        <div class="legend-item">
          <span class="legend-key">Ctrl + Shift + Click</span>
          <span class="legend-desc">Multi-seleccionar</span>
        </div>
        <div class="legend-item">
          <span class="legend-key">Ctrl + Rueda</span>
          <span class="legend-desc">Zoom</span>
        </div>
        <div class="legend-item">
          <span class="legend-key">Ctrl + Arrastrar</span>
          <span class="legend-desc">Mover vista</span>
        </div>
      </div>
    </div>
    <div class="legend-section">
      <h4><i class="fas fa-palette"></i> Estados</h4>
      <div class="status-legend">
        <div class="status-item" *ngFor="let status of getStatusList()">
          <div class="status-color" [style.background]="getStatusColor(status)"></div>
          <span>{{ getStatusLabel(status) }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Reporte -->
  <div class="report-overlay" *ngIf="showSimulationReport" (click)="closeReport()">
    <div class="report-modal" (click)="$event.stopPropagation()" *ngIf="simulationState$ | async as state">
      <div class="report-header">
        <h2><i class="fas fa-chart-line"></i> Reporte de Simulación</h2>
        <button class="close-btn" (click)="closeReport()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="report-content">
        <div class="report-section">
          <h3>Métricas Generales</h3>
          <div class="metrics-grid">
            <div class="metric-card">
              <div class="metric-icon"><i class="fas fa-users"></i></div>
              <div class="metric-info">
                <div class="metric-title">Clientes Totales</div>
                <div class="metric-value">{{ state.metrics.totalCustomers }}</div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon"><i class="fas fa-check-circle"></i></div>
              <div class="metric-info">
                <div class="metric-title">Clientes Atendidos</div>
                <div class="metric-value">{{ state.metrics.customersServed }}</div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon"><i class="fas fa-clock"></i></div>
              <div class="metric-info">
                <div class="metric-title">Tiempo Promedio de Espera</div>
                <div class="metric-value">{{ formatDuration(state.metrics.averageWaitTime) }}</div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon"><i class="fas fa-utensils"></i></div>
              <div class="metric-info">
                <div class="metric-title">Tiempo Promedio de Servicio</div>
                <div class="metric-value">{{ formatDuration(state.metrics.averageServiceTime) }}</div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon"><i class="fas fa-chart-area"></i></div>
              <div class="metric-info">
                <div class="metric-title">Ocupación Máxima</div>
                <div class="metric-value">{{ state.metrics.peakOccupancy }} mesas</div>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-icon"><i class="fas fa-hourglass-half"></i></div>
              <div class="metric-info">
                <div class="metric-title">Tiempo Total</div>
                <div class="metric-value">{{ formatTime(state.elapsedTime) }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="report-section" *ngIf="state.metrics.bottleneckZones.length > 0">
          <h3><i class="fas fa-exclamation-triangle"></i> Cuellos de Botella</h3>
          <div class="bottleneck-list">
            <div class="bottleneck-item" *ngFor="let zone of state.metrics.bottleneckZones">
              <i class="fas fa-map-marker-alt"></i>
              <span>{{ zone }}</span>
            </div>
          </div>
        </div>

        <div class="report-section">
          <h3>Análisis de Capacidad</h3>
          <div class="capacity-analysis">
            <p>Con la configuración actual de mesas y personal, en un tiempo máximo de <strong>{{ formatTime(state.elapsedTime) }}</strong> se pueden atender aproximadamente <strong>{{ calculateCapacity(state) }}</strong> personas.</p>
            <div class="recommendations" *ngIf="state.metrics.bottleneckZones.length > 0">
              <h4>Recomendaciones:</h4>
              <ul>
                <li *ngFor="let zone of state.metrics.bottleneckZones">
                  Considerar agregar más mesas o personal en la zona: {{ zone }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
